// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"a4144716","359":"55258bf0","511":"d639375a"}[chunkId] + ".chunk.js";
};